import React from "react";
import MainInput from "@/components/common/MainInput";
import MainButton from "@/components/common/MainButton";
import { useAppDispatch } from "@/redux/hooks";
import { addPurposeAsync } from "@/redux/slices/purposeSlice";
import { notifyError, notifySuccess } from "@/components/common/MainNotify";
import { CircularProgress } from "@mui/material";

const PurposeAddForm = () => {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = React.useState(false);
  const [formData, setFormData] = React.useState({
    purposeTitle: "",
  });

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);

    const reqData = {
      ...formData,
    };

    // console.log("reqData: ", reqData);
    const res: any = await dispatch(addPurposeAsync(reqData));

    if (res.status === "success") {
      setFormData({
        purposeTitle: "",
      });

      notifySuccess(res.message);
      setLoading(false);
    } else {
      notifyError(res.message);
      setLoading(false);
    }
  };
  return (
    <div>
      <MainInput
        title="Purpose"
        name="purposeTitle"
        placeholder="Enter Puurpose"
        value={formData.purposeTitle}
        setValue={handleOnChange}
        required
      />

      {loading ? (
        <CircularProgress />
      ) : (
        <MainButton type="button" text="Submit" onClick={handleSubmit} />
      )}
    </div>
  );
};

export default PurposeAddForm;
